import { fetchPost, fetchGet } from "@/lib/services";

export interface LoginRequest {
  email?: string;      // Email format
  username?: string;   // Username format
  password: string;
}

// export interface RegisterRequest {
//   parent: {
//     fullName: string;
//     email: string;
//     phone: string;
//     address: string;
//     state?: string;
//     city?: string;
//     password: string;
//     confirmPassword: string;
//   };
//   children: Array<{
//     name: string;
//     class: string;
//     school: string;
//     studentId: string;
//   }>;
// }

export interface RegisterRequest {
    Username: string;
    Email: string;
    Password: string;
    Conform_Password: string;
    Refer: string;
    Phone: string;
}

export async function loginService(credentials: LoginRequest) {
  return await fetchPost("/login/", credentials, false, false,false);
}
 
export async function getUserDetailsService(userId:number) {
    return await fetchGet(`/login/${userId}/`);
}

export async function registerService(data: RegisterRequest) {
  return await fetchPost("/registeredcreate/", data, false, false);
}

export async function refreshTokenService(refreshToken: string) {
    return await fetchPost("/refresh/", { refresh: refreshToken }, false, false,false);
}

export async function logoutService(refreshToken: string) {
    return await fetchPost("/logout/", { refresh: refreshToken });
}

export async function getLoginHistoryService() {
    return await fetchGet("/login-history/");
}

export async function sendResetLinkService(payload: any) {
    return await fetchPost("/send-reset-link/", payload, false, false,false);
}

export async function resendOtpService(payload: any) {
    return await fetchPost("/resend-otp/", payload, false, false,false);
}

export async function sendOtpService(payload: any) {
    return await fetchPost("/reset-password-otp/", payload, false, false,false);
}

export async function verifyResetTokenService(
  token: string
) {
  return await fetchGet(
    `/verify-reset-token/${token}/`
  );
}

export async function resetPasswordService(
  token: string,
  password: string
) {
  return await fetchPost(`/reset-password/${token}/`,{Password: password},
    false,
    false,
    false
  );
}